import { useQuery, useQueryClient } from 'react-query';
import api from 'services';
import type { EmployersResponse } from 'services/requests';
import type { ApiError } from 'services/api.errors';
import { DefaultOrder } from 'types/order';
import { useQueryPage, useQueryOrder } from 'hooks/routes';
import { QueryKeys } from 'constants/queryKeys';
import type { AxiosError } from 'axios';

export const useGetEmployers = () => {
  const queryClient = useQueryClient();
  const { size, page } = useQueryPage();
  const [order, setOrder] = useQueryOrder();
  const defaultOrder: DefaultOrder<'name'> = ['name', 'asc'];

  const queryOrder = !order
    ? { orderBy: defaultOrder[0] }
    : order[1] === 'asc'
    ? { orderBy: order[0] }
    : { orderByDesc: order?.[0] ?? '' };

  const params = {
    page,
    size,
    ...queryOrder,
  };

  const queryKey = [QueryKeys.employers, page, size, order ?? defaultOrder];

  const queryFn = async () => {
    const { data } = await api.getEmployers(params);
    return data;
  };

  return useQuery<EmployersResponse, AxiosError<ApiError>>(queryKey, queryFn, {
    initialData() {
      const data = queryClient.getQueryData<EmployersResponse>(queryKey);
      return data;
    },
    onSuccess: () => {
      if (!order) {
        setOrder(defaultOrder, { replace: true });
      }
    },
  });
};
